import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export function useSearchParam(
  key: string
): [string | null, { set: (value: string) => void; unset: () => void }] {
  const history = useHistory();
  const location = useLocation();

  const value = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  }, [key, location.search]);

  const set = useCallback(
    (value: string) => {
      const params = new URLSearchParams(history.location.search);
      params.set(key, value);
      history.push({ search: params.toString() });
    },
    [key, history]
  );
  const unset = useCallback(() => {
    const params = new URLSearchParams(history.location.search);
    params.delete(key);
    history.push({ search: params.toString() });
  }, [key, history]);
  return [value, { set, unset }];
}
